import { NgModule } from '@angular/core';
import { DataStore } from './model/data-store.svc';
import { DataSync } from './model/data-sync.svc';

@NgModule({
    providers: [ DataStore, DataSync ],
})
export class FluxStore {
}
